import Service from './Service';
import FunnelService from './FunnelService';
import MixpanelService from './MixpanelService';
import {getDocumentElement, getInitialStep} from '-/util/util';
import {UI_INITIALIZE, VALIDATION_REQUEST_AUTH} from '-/actions/types';

const NAVIGATION_SETDATA = 'NAVIGATION_SETDATA';
const NAVIGATION_SET = 'NAVIGATION_SET';
const NAVIGATION_TOGGLE_COAPP = 'NAVIGATION_TOGGLE_COAPP';
const NAVIGATION_REACHED_COAPP = 'NAVIGATION_REACHED_COAPP';
const NAVIGATION_NEXT = 'NAVIGATION_NEXT';
const NAVIGATION_BACK = 'NAVIGATION_BACK';

const reducerName = 'navigation';
const initialStep = getInitialStep();

const resetToTop = () => {
    document.body.scrollTop = getDocumentElement().scrollTop = 0;
};

const getCurrentStepLastSession = (state, currentStep) => {
    const stepsIgnore = [
        'documents',
        'hero',
        'me',
        'new',
        'validationInfo',
        'verifyDob',
        'verifySSN',
        'verifyAccount',
        'verifyAddress',
        'callback',
        'verifyAccountCCR',
        'stips',
        'stipEdit'
    ];
    if (stepsIgnore.indexOf(currentStep) > -1) {
        return state.currentStepLastSession;
    }
    return currentStep;
};

const initialState = {
    lastStep: null,
    currentStep: initialStep,
    reachedReview: false,
    reachedReview_CoApp: false,
    reachedCoApp: false,
    coAppUnlocked: false,
    coApplicantType: null,
    buyerHasCoApp: 'UNANSWERED'
};

const navNext = (state, step, data) => {
    const reachedReviewKey = state.reachedCoApp ? 'reachedReview_CoApp' : 'reachedReview';
    const reachedReview = state.reachedCoApp ? state.reachedReview_CoApp : state.reachedReview;
    return  {
        ...state,
        lastStep: state.currentStep,
        currentStep: step,
        currentStepLastSession: getCurrentStepLastSession(state, step),
        [reachedReviewKey]: reachedReview || step === 'finalReview',
        currentStepData: data,
        previousY: getDocumentElement().scrollTop,
        isBack: false
    };
};

const set = (state, key, value) => {
    return {
        ...state,
        [key]: value
    };
};

const reducer = (state = initialState, action) => {
    const {type, payload, value} = action;

    switch (type) {
        case UI_INITIALIZE:
            return {
                ...state,
                ...value.navigation
            };
        case NAVIGATION_NEXT: {
            const {step, data} = payload;
            return navNext(state, step, data);
        }
        case NAVIGATION_BACK:
            return {
                ...state,
                currentStep: payload,
                currentStepLastSession: getCurrentStepLastSession(state, payload),
                isBack: true
            };
        case NAVIGATION_SETDATA:
            return {
                ...state,
                ...payload
            };
        case NAVIGATION_SET: {
            const {key, value} = payload;
            return set(state, key, value);
        }
        case NAVIGATION_REACHED_COAPP:
            return {
                ...state,
                reachedCoApp: true,
                coAppUnlocked: true
            };
        case NAVIGATION_TOGGLE_COAPP:
            return {
                ...state,
                reachedCoApp: payload
            };
    }

    return state;
};

class NavigationService extends Service {
    constructor() {
        super();

        if (!NavigationService.instance) {
            NavigationService.instance = this;
        }
        return NavigationService.instance;
    }

    getReducerName() {
        return reducerName;
    }

    getReducer() {
        return reducer;
    }

    startOver() {
        this.store.dispatch({
            type: NAVIGATION_SETDATA,
            payload: {
                currentStep: initialStep
            }
        });
        this.store.dispatch({
            type: VALIDATION_REQUEST_AUTH
        });
        resetToTop();
    }

    next(step, data) {
        const {currentStep} = this.getReducerState() || {};

        MixpanelService.navNextOrBack(step);
        FunnelService.stepViewed(step, currentStep);

        this.store.dispatch({
            type: NAVIGATION_NEXT,
            payload: {
                step,
                data
            }
        });

        resetToTop();
    }

    goBack() {
        const {lastStep} = this.getReducerState();
        this.store.dispatch({
            type: NAVIGATION_BACK,
            payload: lastStep
        });
    }

    back(step) {
        const {currentStep} = this.getReducerState() || {};

        MixpanelService.navNextOrBack(step);
        FunnelService.stepViewed(step, currentStep);

        this.store.dispatch({
            type: NAVIGATION_BACK,
            payload: step
        });
    }

    set(key, value) {
        this.store.dispatch({
            type: NAVIGATION_SET,
            payload: {
                key,
                value
            }
        });
    }

    setData(data) {
        this.store.dispatch({
            type: NAVIGATION_SETDATA,
            payload: data
        });
    }

    toggleCoApplicant(reachedCoApp) {
        this.store.dispatch({
            type: NAVIGATION_TOGGLE_COAPP,
            payload: !!reachedCoApp
        });
    }

    isCoApplicant() {
        return this.getReducerState().reachedCoApp;
    }

    getDataForSave() {
        const obj = {...this.getReducerState()};
        delete obj.currentStep;

        if (obj.coApplicantType === null) {
            delete obj.coApplicantType;
        }

        if (obj.buyerHasCoApp === 'YESPREVIOUSCOAPP') {
            obj.buyerHasCoApp = 'YES';
        }

        return obj;
    }

    showReviewButton() {
        const {reachedCoApp, reachedReview_CoApp, reachedReview} = this.getReducerState();
        return reachedCoApp ? reachedReview_CoApp : reachedReview;
    }

    setReachedCoApp() {
        this.store.dispatch({
            type: NAVIGATION_REACHED_COAPP
        });
    }
}

export default new NavigationService();
